import { gql } from '@apollo/client';

export * from './company.query.generated';

export const COMPANY = gql`
  query company {
    company {
      city
      invitationStatus
      companyName
      companyRegistration
      companyWebsite
      country
      id
      postalCode
      region
      street
      streetNumber
      subscriptionCancellationRequestedAt
      subscriptionExclusiveCouponAppliedAt
      ssoEnabled
      policy {
        createUser
        update
        readBilling
        createIntegration
        readIntegrations
        readAuditLog
      }
    }
  }
`;
